// Convert DB courseType to our internal comboKey (e.g., 'nano+ombre')
export function normalizeCourseType(courseType = "") {
  const t = String(courseType || "").toLowerCase().replace(/[\s_-]+/g, "");
  if (t === "nanocombo" || t === "nanocombobrows") return "nanocombo";
  if (t.includes("nanocombo") && t.includes("lip")) return "nanocombo+lip";
  if (t === "nano") return "nano";
  if (t === "ombre") return "ombre";
  if (t === "lips" || t === "lip" || t === "lipblush") return "lip";

  if (t.includes("nano") && t.includes("ombre") && t.includes("lip")) return "nano+ombre+lip";
  if ((t.includes("nano") && t.includes("ombre")) || t === "nano-ombre") return "nano+ombre";
  if ((t.includes("ombre") && (t.includes("lip") || t.includes("lips"))) || t === "ombre-lips") return "ombre+lip";
  if ((t.includes("nano") && (t.includes("lip") || t.includes("lips"))) || t === "nano-lips") return "nano+lip";
  return ""; // unknown
}

// Build an array of normalized course records
export function selectCourses(state) {
  const s = state.entities?.courses || state.courses || {};
  const list = (s.allIds || []).map((id) => s.byId[id]).filter(Boolean);
  return list.map((c) => ({
    ...c,
    _id: c._id?.$oid || c._id,
    key: normalizeCourseType(c.courseType),
    // extract numeric price if cost like "$2900"
    priceNum: Number(String(c.cost || "").replace(/[^\d.]/g, "")) || null,
  }));
}

// Given a selection comboKey like "nano+ombre", return unsold matching date options
export function selectOptionsForSelection(state, comboKey) {
  const items = selectCourses(state);
  return items
    .filter((c) => c.sold === false && c.key === comboKey)
    .sort((a, b) => String(a.dates).localeCompare(String(b.dates)));
}
